import { render, staticRenderFns } from "./JourneyStatistics.vue?vue&type=template&id=7b6b4aeb&scoped=true&"
import script from "./JourneyStatistics.vue?vue&type=script&lang=js&"
export * from "./JourneyStatistics.vue?vue&type=script&lang=js&"
import style0 from "./JourneyStatistics.vue?vue&type=style&index=0&id=7b6b4aeb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b6b4aeb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("Q:\\Projects\\dnx-dpn\\MarketingDb.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7b6b4aeb')) {
      api.createRecord('7b6b4aeb', component.options)
    } else {
      api.reload('7b6b4aeb', component.options)
    }
    module.hot.accept("./JourneyStatistics.vue?vue&type=template&id=7b6b4aeb&scoped=true&", function () {
      api.rerender('7b6b4aeb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/JourneyBuilder/Components/Statistics/JourneyStatistics.vue"
export default component.exports